module.exports = __webpack_public_path__ + "static/img/contactbanner.920d8f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactbanner.jpg
// module id = 287
// module chunks = 2